import galoMonitorApi from '../apis/galoMonitorApi/api'
import useFetch from './useFetch'

const useGaloMonitorApi = (url, ...axiosParams) => useFetch(galoMonitorApi, url, ...axiosParams)

export default useGaloMonitorApi
